/**
 * Reading the list contract on the browser side.
 *
 * The server never truncates a list silently (see `backend/utils/list_query.py`):
 * it reports the true total for the filter and flags when more rows matched than it
 * returned. This module turns that into something the UI can act on, so a page can
 * never again filter, sort or count a partial book without saying so.
 */

/** Meta from a list response's headers. `total` is the TRUE total for the filter. */
export function readListMeta(response) {
  const h = response?.headers || {};
  const num = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };
  const total = num(h['x-total-count']);
  const count = num(h['x-result-count']);
  const data = response?.data;
  const returned = count ?? (Array.isArray(data) ? data.length
    : Array.isArray(data?.items) ? data.items.length : null);
  return {
    total,
    returned,
    skip: num(h['x-result-skip']) ?? 0,
    limit: num(h['x-result-limit']),
    ceiling: num(h['x-result-ceiling']),
    truncated: h['x-result-truncated'] === 'true',
    // The server clamped the window the caller asked for.
    clamped: h['x-result-ceiling'] != null,
  };
}

/** "Showing the first 500 of 12,431" — the sentence used by the bar and the toast. */
export function truncationSentence(meta, noun = 'rows') {
  if (!meta?.truncated) return null;
  const shown = (meta.skip || 0) + (meta.returned || 0);
  const fmt = (n) => n.toLocaleString('en-GB');
  if (meta.total != null) {
    return `Showing ${fmt(shown)} of ${fmt(meta.total)} ${noun}`;
  }
  return `Showing the first ${fmt(shown)} ${noun} — there may be more`;
}
